import React, { Component } from 'react';
import Chart from 'react-apexcharts';
import {
    getComparisonRAAperRA,
    getBarComparisonRAperRAAOptions
} from '../utilities/dataTransformer';


class BarChartRAAeachRA extends Component {
    constructor(props) {
        super(props);

        var comparisonRAAperRA = getComparisonRAAperRA();

       

        this.state = {

            options: getBarComparisonRAperRAAOptions(),
            series: [{
                name: '2010',
                data: comparisonRAAperRA[2010][0]
            },
            {
                name: '2018',
                data: comparisonRAAperRA[2018][0]
            },
            {
                name: '2019',
                data: comparisonRAAperRA[2019][0]
            },
            {
                name: '2020',
                data: comparisonRAAperRA[2020][0]
            },

            ]
        };
    }


    componentDidUpdate(prevState) {
        if (this.state.shouldUpdate) {
            this.setState({
                ...this.state,
                shouldUpdate: false,
            });
            var comparisonRAAperRA = getComparisonRAAperRA();

            this.setState({
                options: getBarComparisonRAperRAAOptions(),

                series: [{
                    name: '2010',
                    data: comparisonRAAperRA[2010][0]
                },
                {
                    name: '2018',
                    data: comparisonRAAperRA[2018][0]
                },
                {
                    name: '2019',
                    data: comparisonRAAperRA[2019][0]
                },
                {
                    name: '2020',
                    data: comparisonRAAperRA[2020][0]
                },

                ]
            })
        }
    }
    render() {
        return (
            <div className="chart-container">

            <Chart
                options={this.state.options}
                series={this.state.series}
                type='bar'
                height="100%"
                width="100%"
            /></div>
        );
    }
}

export default BarChartRAAeachRA;